import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import RoseDemoApp from './demo/App'
import './rose.css'

const ROSE_HOSTS = new Set(['therosephoto.com', 'www.therosephoto.com'])

function isRoseRootExperience() {
  return ROSE_HOSTS.has(window.location.hostname)
    || document.documentElement.dataset.brand === 'rose'
}

function buildRosePath(prefix, path = '') {
  const cleanPath = path.replace(/^\/+/, '')
  if (!cleanPath) return prefix || '/'
  return `${prefix}/${cleanPath}`
}

const routeConfig = [
  { path: '', view: 'home' },
  { path: 'gallery', view: 'lookbook' },
  { path: 'lookbook', view: 'lookbook' },
  { path: 'stories', view: 'stories' },
  { path: 'contact', view: 'inquiry' },
  { path: 'waitlist', view: 'inquiry' },
  { path: 'about', view: 'about' },
  { path: 'how-it-works', view: 'how-it-works' },
  { path: 'terms', view: 'terms-privacy', legalTab: 'terms' },
  { path: 'privacy', view: 'terms-privacy', legalTab: 'privacy' },
  { path: 'contract', view: 'terms-privacy', legalTab: 'contract' },
]

function RoseMeta() {
  useEffect(() => {
    document.title = 'The Rose Photo'

    const description = 'The Rose Photo creates timeless wedding photographs through a highly personal, intentionally limited waitlist experience.'
    let meta = document.querySelector('meta[name="description"]')
    if (!meta) {
      meta = document.createElement('meta')
      meta.setAttribute('name', 'description')
      document.head.appendChild(meta)
    }
    meta.setAttribute('content', description)

    let icon = document.querySelector('link[rel="icon"]')
    if (!icon) {
      icon = document.createElement('link')
      icon.setAttribute('rel', 'icon')
      document.head.appendChild(icon)
    }
    icon.setAttribute('type', 'image/png')
    icon.setAttribute('href', '/rose/rp-rose-favicon.png')
  }, [])

  return null
}

function RosePage({ basePath, initialView, initialLegalTab }) {
  return (
    <>
      <RoseMeta />
      <RoseDemoApp
        basePath={basePath}
        initialView={initialView}
        initialLegalTab={initialLegalTab}
      />
    </>
  )
}

export function isRoseExperience() {
  return isRoseRootExperience()
    || window.location.pathname === '/rose'
    || window.location.pathname.startsWith('/rose/')
}

export default function RoseApp() {
  const isRoseDomain = isRoseRootExperience()
  const prefix = isRoseDomain ? '' : '/rose'
  const waitlistPath = buildRosePath(prefix, 'contact')

  return (
    <Routes>
      {routeConfig.map(({ path, view, legalTab }) => (
        <Route
          key={path || 'home'}
          path={buildRosePath(prefix, path)}
          element={(
            <RosePage
              basePath={prefix}
              initialView={view}
              initialLegalTab={legalTab}
            />
          )}
        />
      ))}
      <Route path={buildRosePath(prefix, 'faq')} element={<Navigate to={buildRosePath(prefix, 'how-it-works')} replace />} />
      <Route path={buildRosePath(prefix, 'book')} element={<Navigate to={waitlistPath} replace />} />
      <Route path={buildRosePath(prefix, 'book/success')} element={<Navigate to={waitlistPath} replace />} />
      <Route path="*" element={<Navigate to={buildRosePath(prefix)} replace />} />
    </Routes>
  )
}
